var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    clipPath: "url(#clip0_20_2501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3.99997L8.79996 7.19997L10.4 8.79998L13.6 5.59997C14.92 4.27997 17.08 4.27997 18.4 5.59997C19.72 6.91997 19.72 9.07998 18.4 10.4L15.2 13.6L16.8 15.2L20 12C22.208 9.79198 22.208 6.20797 20 3.99997C17.792 1.79196 14.208 1.79196 12 3.99997ZM13.6 15.2L10.4 18.4C9.07997 19.72 6.91996 19.72 5.59996 18.4C4.27995 17.08 4.27995 14.92 5.59996 13.6L8.79996 10.4L7.19996 8.79998L3.99995 12C1.79194 14.208 1.79194 17.792 3.99995 20C6.20796 22.208 9.79197 22.208 12 20L15.2 16.8L13.6 15.2ZM7.99996 14.4L14.4 7.99998L16 9.59998L9.59997 16L7.99996 14.4Z",
    fill: "#A1A8B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_2501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0b0af9c37f02ea74d42be5f56d196a1d.svg";
export { ForwardRef as ReactComponent };